export const CART_ITEM_DELETED_EVENT = 'cart.item.deleted';

export interface CartItemDeletedEvent {
  itemId: string;
  photoId: string;
}
